import { Navigate, useParams } from 'react-router-dom';

import { LoadingState } from '../../components/loading-state';
import { useGetTranscriptDetailsQuery } from '../../store/api';
import { resourceDetailPath } from '../../utils/resource-routes';

/**
 * Forwards the pre-consolidation transcript URLs to the canonical one
 * (GDN-2726). See note-redirect for why these shims exist.
 *
 * Transcription sessions are `scope="user"` and their documents carry
 * `organization_id` only additively, so the owning provider's org is the
 * fallback when the session itself has none.
 */
export default function TranscriptRedirect() {
  const { transcriptId: scoped, id: legacy } = useParams<{
    transcriptId?: string;
    id?: string;
  }>();
  const transcriptId = scoped || legacy || '';

  const { data, isLoading } = useGetTranscriptDetailsQuery(
    { transcriptionId: transcriptId },
    { skip: !transcriptId },
  );

  if (!transcriptId) return <Navigate to="/admin-v2" replace />;
  if (isLoading) return <LoadingState message="Opening transcript..." />;

  const organizationId =
    data?.transcription?.organization_id ?? data?.provider?.organization_id;
  if (!organizationId) return <Navigate to="/admin-v2" replace />;

  return (
    <Navigate
      to={resourceDetailPath(
        { organizationId },
        'transcription_session',
        transcriptId,
      )}
      replace
    />
  );
}
